export enum DiscriminationKey {
  ASSET = "asset",
  SERVICE = "service"
}
